// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IV1GetOrCreateChatRequest {
  /** URL страницы, с которой был инициирован чат **/
  pageUrl?: TV1GetOrCreateChatRequest_PageUrl;
  /** JSON query **/
  jsonQuery?: TV1GetOrCreateChatRequest_JsonQuery;
  /** Страница, с которой был инициирован чат **/
  sourcePage?: TV1GetOrCreateChatRequest_SourcePage;
}

export type TV1GetOrCreateChatRequest_PageUrl = null | string;

export type TV1GetOrCreateChatRequest_JsonQuery = null | TV1GetOrCreateChatRequest_JsonQuery_1;

export type TV1GetOrCreateChatRequest_JsonQuery_1 = object;

export type TV1GetOrCreateChatRequest_SourcePage = null | ESourcePage;

export enum ESourcePage {
  /** Выдача новостроек **/
  'NewbuildingsList' = 'newbuildingsList',
  /** Выдача объявлений **/
  'OffersList' = 'offersList',
  /** Карточка объявления **/
  'OfferCard' = 'offerCard',
  /** Карточка новостройки **/
  'NewbuildingCard' = 'newbuildingCard',
  /** Список чатов **/
  'ChatsList' = 'chatsList',
}
